module.exports = __webpack_public_path__ + "static/media/halo-fix-mobile.bf27f795.svg";